document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('#CartDrawer');
  const closeButtons = drawer?.querySelectorAll('[data-cart-drawer-close]');
  const bagIcon = document.querySelector('[data-cart-icon]');

  /** === Drawer Controls === */
  const openDrawer = () => {
    drawer.classList.add('active');
    drawer.setAttribute('aria-hidden', 'false');
  };

  const closeDrawer = () => {
    drawer.classList.remove('active');
    drawer.setAttribute('aria-hidden', 'true');
  };

  /** === Refresh Drawer + Header Count (parallel fetches) === */
  const refreshDrawer = () => {
    return Promise.all([
      fetch('/cart?view=drawer').then(res => res.text()),
      fetch('/cart.js').then(res => res.json())
    ])
      .then(([html, cart]) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Update items
        const newItems = doc.querySelector('[data-cart-drawer-items]');
        drawer.querySelector('[data-cart-drawer-items]').innerHTML =
          newItems.innerHTML;

        // Update free shipping bar
        const newShipping = doc.querySelector('[data-cart-drawer-shipping]');
        if (newShipping) {
          drawer.querySelector('[data-cart-drawer-shipping]').innerHTML =
            newShipping.innerHTML;
        }

        // Update footer
        const newFooter = doc.querySelector('.cart-drawer__footer');
        const footerTarget = drawer.querySelector('.cart-drawer__footer');
        if (newFooter && footerTarget) {
          footerTarget.innerHTML = newFooter.innerHTML;
        } else if (!newFooter && footerTarget) {
          footerTarget.remove();
        } else if (newFooter && !footerTarget) {
          drawer.querySelector('.cart-drawer__inner').appendChild(newFooter);
        }

        // 🔑 Update header cart count
        const headerCount = document.querySelector('[data-header-cart-count]');
        if (headerCount) {
          if (cart.item_count > 0) {
            headerCount.setAttribute('data-header-cart-count', cart.item_count);
            headerCount.classList.add('visible');
          } else {
            headerCount.setAttribute('data-header-cart-count', '');
            headerCount.classList.remove('visible');
          }
        }

        // Update complimentary products
const newComplimentary = doc.querySelector('[data-cart-drawer-complimentary]');
const targetComplimentary = drawer.querySelector('[data-cart-drawer-complimentary]');
if (targetComplimentary) {
  if (newComplimentary) {
    targetComplimentary.innerHTML = newComplimentary.innerHTML;
  } else {
    targetComplimentary.innerHTML = ''; // clear it if none
  }
}



        attachQuantityListeners();
        toggleMinusButtons();
      });
  };

  /** === Cart Line Update === */
  const updateCartLine = (line, quantity) => {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        line: parseInt(line, 10),
        quantity: parseInt(quantity, 10)
      })
    })
      .then(res => res.json())
      .then(() => refreshDrawer());
  };

  /** === Minus Button State === */
  const toggleMinusButtons = () => {
    const inputs = drawer.querySelectorAll('[data-quantity-input]');
    inputs.forEach(input => {
      const wrapper = input
        .closest('[data-quantity-selector]')
        ?.querySelector('[data-button-wrapper-minus]');
      if (!wrapper) return;

      const minusButton = wrapper.querySelector('[data-quantity-minus]');
      if (parseInt(input.value, 10) <= 1) {
        wrapper.classList.add('quantity-selector__button-wrapper--disabled');
        minusButton.setAttribute('disabled', 'disabled');
      } else {
        wrapper.classList.remove('quantity-selector__button-wrapper--disabled');
        minusButton.removeAttribute('disabled');
      }
    });
  };

  /** === Quantity / Remove Listeners === */
  const attachQuantityListeners = () => {
    const inputs = drawer.querySelectorAll('[data-quantity-input]');
    const plusButtons = drawer.querySelectorAll('[data-quantity-plus]');
    const minusButtons = drawer.querySelectorAll('[data-quantity-minus]');
    const removeButtons = drawer.querySelectorAll('[data-cartitem-remove]');

    // Input change
    inputs.forEach((input, i) => {
      input.addEventListener('change', e => {
        updateCartLine(i + 1, e.target.value);
      });
    });

    // Plus button
    plusButtons.forEach((btn, i) => {
      btn.addEventListener('click', () => {
        const input = inputs[i];
        const newQty =
          parseInt(input.value, 10) +
          parseInt(input.dataset.incrementValue || 1, 10);
        updateCartLine(i + 1, newQty);
      });
    });

    // Minus button
    minusButtons.forEach((btn, i) => {
      btn.addEventListener('click', () => {
        const input = inputs[i];
        const newQty = Math.max(
          0,
          parseInt(input.value, 10) -
            parseInt(input.dataset.incrementValue || 1, 10)
        );
        updateCartLine(i + 1, newQty);
      });
    });

    // Remove button
    removeButtons.forEach((btn, i) => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        updateCartLine(i + 1, 0); // set quantity to 0 to remove
      });
    });

    toggleMinusButtons(); // initialize states
  };

  /** === Events === */
  // Bag icon opens drawer
  if (bagIcon) {
    bagIcon.addEventListener('click', e => {
      e.preventDefault();
      openDrawer();
      refreshDrawer();
    });
  }

  // Close drawer
  closeButtons?.forEach(btn => btn.addEventListener('click', closeDrawer));
  const overlay = document.querySelector('.cart-drawer__overlay');
  if (overlay) {
    overlay.addEventListener('click', closeDrawer);
  }

  // Open drawer after product is added
  document.addEventListener('product:added', () => {
    openDrawer();
    refreshDrawer();
  });
});
